import './App.css';
import Header from './components/Header';
import Form from './components/Form';

function App() {
  return (
    <>
    <Header/>
    <Form/>
    </>
  );
}

export default App;
